// extracted by mini-css-extract-plugin
export default {"firstPartText":"W-K_c","secondPartText":"_26fN0"};